/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Error_Pdf_UnavailableInputs */

const vi_einvoice_error_pdf_unavailable = /** @type {(inputs: Einvoice_Error_Pdf_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tải được file PDF hóa đơn từ MISA. Vui lòng thử lại sau vài phút.`)
};

/**

* @param {Einvoice_Error_Pdf_UnavailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_error_pdf_unavailable = /** @type {((inputs?: Einvoice_Error_Pdf_UnavailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Error_Pdf_UnavailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_error_pdf_unavailable(inputs)
});